import {RouteDefinition} from "../../../routes"
import {FrameEditorContentEditScreen} from "./FrameEditorContentEditScreen"
import {FrameEditorContentListScreen} from "./FrameEditorContentListScreen"
import {FrameEditorListScreen} from "./FrameEditorListScreen"

export const FrameEditorRoutes: RouteDefinition[] = [
    {
        routerLink: "/settings/frame-editor",
        component: FrameEditorListScreen
    },
    {
        routerLink: "/settings/frame-editor/:id",
        component: FrameEditorContentListScreen
    },
    {
        routerLink: "/settings/frame-editor/:device_id/content/",
        component: FrameEditorContentEditScreen
    },
    {
        routerLink: "/settings/frame-editor/:device_id/content/:id",
        component: FrameEditorContentEditScreen
    }
]
